import { useEffect } from 'react'
import { init } from 'ucho-js'

/**
 * ClientCare project the feedback lands in. Grantový diář is one client, the rest of the admin
 * (Obsah webu, Kurzy, objednávky, …) is Svět neziskovek — decided per submit from the current URL,
 * so the widget survives client-side navigation between the two sections.
 */
const clientCareProject = () => (window.location.pathname.startsWith('/gd') ? 'grantovy-diar' : 'svet-neziskovek')

/** Feedback widget wired to the client's ClientCare board. Off in dev so local noise never reaches the board. */
export const UchoWidget = () => {
	useEffect(() => {
		if (import.meta.env.DEV) return

		return init({
			textConfig: {
				welcomeMessage: {
					text: 'Klikněte zde pro zanechání zpětné vazby',
					closeAriaLabel: 'Zavřít uvítací zprávu',
				},
				feedbackForm: {
					title: 'Odeslat zpětnou vazbu',
					placeholder: 'Co máte na mysli? Rádi bychom slyšeli vaši zpětnou vazbu',
					screenshotAlt: 'Náhled snímku obrazovky',
					submitButton: 'Odeslat zpětnou vazbu',
					minimizeTitle: 'Minimalizovat',
					expandTitle: 'Rozbalit',
					closeTitle: 'Zavřít',
					showFormTitle: 'Zobrazit formulář zpětné vazby',
				},
				notification: {
					successTitle: 'Děkujeme za vaši zpětnou vazbu!',
					errorTitle: 'Něco se pokazilo.',
					errorMessage: 'Nepodařilo se odeslat zpětnou vazbu. Zkuste to prosím znovu.',
					hideTitle: 'Skrýt oznámení',
				},
				drawingTooltip: {
					text: 'Klikněte a táhněte pro kreslení',
				},
			},
			onSubmit: async data =>
				fetch(`https://clientcare.contember.com/ucho/project/${clientCareProject()}/task`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(data),
				}),
		})
	}, [])

	return null
}
